const errorHandler = () => next => action => {
  if (action.type.includes('_FAILURE')) {
    console.error('ERROR: ', action.payload);
  }
  return next(action);
};

export default errorHandler;
